;"use strict";


$(function () {
    $('input[type="text"]').blur(function(){
        var tmpval = $(this).val();
        if(tmpval == '') {
            $(this).next('.placeholder').addClass('empty');
            $(this).next('.placeholder').removeClass('not-empty');
        } else {
            $(this).next('.placeholder').addClass('not-empty');
            $(this).next('.placeholder').removeClass('empty');
        }
    });

    $('textarea').blur(function(){
        var tmpval = $(this).val();
        if(tmpval == '') {
            $(this).next('.placeholder').addClass('empty');
            $(this).next('.placeholder').removeClass('not-empty');
        } else {
            $(this).next('.placeholder').addClass('not-empty');
            $(this).next('.placeholder').removeClass('empty');
        }
    });
});

$(function () {
    $('input[type="email"]').blur(function(){
        var tmpval = $(this).val();
        if(tmpval == '') {
            $(this).next('.placeholder').addClass('empty');
            $(this).next('.placeholder').removeClass('not-empty');
           
        } else {
            $(this).next('.placeholder').addClass('not-empty');
            $(this).next('.placeholder').removeClass('empty');
        }
    });
});

var $carousel = $(".delivery_info__inner");
function showSliderScreen($widthScreen) {
    if ($widthScreen <= 992) {
        if (!$carousel.hasClass("slick-initialized")) {
            $carousel.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 200,
                arrows: true,
                prevArrow: $(".slider__item-btn_prev"),
                nextArrow: $(".slider__item-btn_next"),
                centerMode: true,
                infinite: false
            });
        }
    } else {
        if ($carousel.hasClass("slick-initialized")) {
            $carousel.slick("unslick");
        }
    }
}

var widthScreen = $(window).width();
$(window).on("ready load resize", function () {
    widthScreen = $(window).width();
    setTimeout(function (){
        showSliderScreen(widthScreen);
    }, 100);
});
